import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const Scrim = styled.div`
  position: fixed;
  inset: 0;
  z-index: 999998;
  background: rgba(10, 10, 12, 0.55);
  backdrop-filter: blur(2px);
`

export const Panel = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  height: 100vh;
  width: min(460px, 94vw);
  z-index: 999999;
  background: ${tokens.surface.base};
  border-left: 1px solid ${tokens.border.strong};
  box-shadow: ${tokens.shadow.card};
  display: flex;
  flex-direction: column;
  overflow: hidden;
`

export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.5rem;
  border-bottom: 1px solid ${tokens.border.hairline};
`

export const Identity = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-width: 0;
`

export const AvatarBox = styled.div`
  width: 2.75rem;
  height: 2.75rem;
  border-radius: 100%;
  overflow: hidden;
  flex: none;
  background: ${tokens.surface.inset};

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

export const IdentityText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  min-width: 0;
`

export const Name = styled.span`
  font-size: ${tokens.font.h1};
  font-weight: 600;
  color: ${tokens.text.primary};
`

export const Meta = styled.span`
  font-size: ${tokens.font.label};
  color: ${tokens.text.muted};
`

export const CloseBtn = styled.button`
  width: 2rem;
  height: 2rem;
  display: grid;
  place-items: center;
  flex: none;
  border-radius: ${tokens.radius.control};
  background: ${tokens.surface.inset};
  border: 1px solid ${tokens.border.hairline};
  color: ${tokens.text.secondary};
  cursor: pointer;
  transition: color 0.15s ease, border-color 0.15s ease;

  &:hover {
    color: ${tokens.accent.base};
    border-color: ${tokens.accent.base};
  }
`

export const Body = styled.div`
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  overflow-y: auto;
  flex: 1;
`

export const PillRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
`

export const PillGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

export const Code = styled.span`
  font-size: ${tokens.font.label};
  font-variant-numeric: tabular-nums;
  color: ${tokens.text.muted};
`

export const DateCards = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem;
`

export const DateCard = styled.div`
  padding: 1rem;
  border-radius: ${tokens.radius.control};
  background: ${tokens.surface.inset};
  border: 1px solid ${tokens.border.hairline};
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
`

export const MiniLabel = styled.span`
  font-size: ${tokens.font.micro};
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${tokens.text.muted};
`

export const MiniValue = styled.span<{ $danger?: boolean }>`
  font-size: ${tokens.font.body};
  font-weight: 600;
  color: ${(p) => (p.$danger ? tokens.status.danger.fg : tokens.text.primary)};
`

export const MetaGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
`

export const MetaItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`

export const BalanceBox = styled.div<{ $danger?: boolean }>`
  padding: 0.875rem 1rem;
  border-radius: ${tokens.radius.control};
  background: ${tokens.surface.inset};
  border: 1px solid ${(p) => (p.$danger ? tokens.status.danger.fg : tokens.border.hairline)};
  display: flex;
  justify-content: space-between;
  gap: 0.75rem;
`

export const BalanceCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  align-items: center;
`

export const Reason = styled.p`
  font-size: ${tokens.font.body};
  line-height: 1.5;
  color: ${tokens.text.secondary};
`

export const Callout = styled.div`
  padding: 0.875rem 1rem;
  border-radius: ${tokens.radius.control};
  background: ${tokens.status.info.bg};
  border: 1px solid ${tokens.status.info.fg};
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
`

export const CalloutTitle = styled.span`
  font-size: ${tokens.font.label};
  font-weight: 600;
  color: ${tokens.status.info.fg};
`

export const CalloutText = styled.span`
  font-size: ${tokens.font.micro};
  color: ${tokens.text.secondary};
`

export const NoteLabel = styled.span`
  font-size: ${tokens.font.micro};
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${tokens.text.muted};
  margin-bottom: 0.4rem;
  display: block;
`

export const NoteInput = styled.textarea`
  width: 100%;
  min-height: 3.5rem;
  resize: vertical;
  padding: 0.625rem 0.75rem;
  border-radius: ${tokens.radius.control};
  background: ${tokens.surface.inset};
  border: 1px solid ${tokens.border.hairline};
  color: ${tokens.text.primary};
  font-size: ${tokens.font.body};
  font-family: inherit;
  outline: none;

  &::placeholder {
    color: ${tokens.text.muted};
  }

  &:focus {
    border-color: ${tokens.accent.base};
  }
`

export const DecisionBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 0.875rem 1rem;
  border-radius: ${tokens.radius.control};
  background: ${tokens.surface.inset};
  border: 1px solid ${tokens.border.hairline};
`

export const Actions = styled.div`
  display: flex;
  gap: 0.625rem;
  padding: 1.25rem 1.5rem;
  border-top: 1px solid ${tokens.border.hairline};

  button {
    flex: 1;
  }
`
